/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// MENU > INDICATOR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	menuindicator: {
		cursor: 'pointer',
		transition: theme.animation.general('all'),
		'&:hover': {
			filter: 'brightness(85%)'
		}
	}
});